/// <reference types="jquery" />
/// <reference types="daterangepicker" />
import React from "react";

export default class DateRangePickerWrapper extends React.Component<DateRangePickerWrapperProps>  {
    private textInput = React.createRef<HTMLInputElement>();

    private jqueryTextInput: JQuery<HTMLInputElement> | undefined;

    constructor(props: DateRangePickerWrapperProps) {
        super(props);
        this.state = { dateValue: '' };
        this.handleApply = this.handleApply.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidMount() {
        const inputElement = this.textInput.current;
        if (!inputElement) {
            return;
        }

        this.jqueryTextInput = $(inputElement);
        this.jqueryTextInput.daterangepicker({
            "locale": {
                "format": "YYYY/MM/DD",
                "separator": " - ",
                "applyLabel": "適用",
                "cancelLabel": "クリア",
                "fromLabel": "から",
                "toLabel": "まで",
                "customRangeLabel": "カスタム",
                "weekLabel": "週",
                "daysOfWeek": [
                    "日",
                    "月",
                    "火",
                    "水",
                    "木",
                    "金",
                    "土"
                ],
                "monthNames": [
                    "1月",
                    "2月",
                    "3月",
                    "4月",
                    "5月",
                    "6月",
                    "7月",
                    "8月",
                    "9月",
                    "10月",
                    "11月",
                    "12月"
                ],
                "firstDay": 0,
            },
            autoUpdateInput: false
        });

        this.jqueryTextInput.on('apply.daterangepicker', this.handleApply);
        this.jqueryTextInput.on('cancel.daterangepicker', this.handleClear);
    }

    componentWillUnmount() {
        if (this.jqueryTextInput) {
            const instance = this.jqueryTextInput.data('daterangepicker');
            if (instance) {
                instance.remove();
            }
            this.jqueryTextInput.off('apply.daterangepicker');
            this.jqueryTextInput.off('cancel.daterangepicker');
        }
    }

    handleApply(event: Event, picker: daterangepicker.DateRangePicker) {
        this.props.onSetDate(picker.startDate.format("YYYY/MM/DD"), picker.endDate.format("YYYY/MM/DD"));
    }

    handleClear(event: Event, picker: daterangepicker.DateRangePicker) {
        this.props.onSetDate('', '');
    }

    render() {
        const dateValue = (this.props.startDateValue && this.props.endDateValue) ? (this.props.startDateValue + ' - ' + this.props.endDateValue) : '';
        return (
            <input type="text" className="form-control bg-white" name="date" value={dateValue} ref={this.textInput} readOnly />
        );
    }
}

interface DateRangePickerWrapperProps {
    startDateValue: string;
    endDateValue: string;
    onSetDate: (startDate: string, endDate: string) => any;
}